import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LocalesActions } from './locales.actions';
import { LocalesSelectors } from './locales.selectors';
import {ItemLocale, Locale, LocaleMappings} from '@emm/core/models/locale.model';
import {Store} from '@ngrx/store';
import {State as CoreState} from '@emm/core/store/core.reducer';

export interface LocalesQueries {
    attributeSelectedLocales$: Observable<ItemLocale>;
    localeMappings$: Observable<LocaleMappings>;
    localeOptions$: Observable<Locale[]>;
    localeSelected$: Observable<Locale>;
    origin$: Observable<string>;
    saved$: Observable<boolean>;
}

@Injectable({ providedIn: 'root' })
export class LocalesStoreService {

    dispatch = {
        // tslint:disable-next-line:max-line-length
        getAttributeLocaleFields: (itemTag, attributeTag) => this.store.dispatch(LocalesActions.loadAttributeLocaleFields({ itemTag, attributeTag })),
        getLocaleMappings: () => this.store.dispatch(LocalesActions.loadLocaleMappings()),
        getLocaleOptions: () => this.store.dispatch(LocalesActions.loadLocaleOptions()),
        init: () => this.store.dispatch(LocalesActions.localeInit()),
        resetSaved: () => this.store.dispatch(LocalesActions.resetSaved()),
        // tslint:disable-next-line:max-line-length
        saveAttributeLocaleFields: (itemTag, updatedFields, origin) => this.store.dispatch(LocalesActions.saveAttributeLocaleFields({ itemTag, updatedFields, origin })),
        selectedLocale: (locale: Locale) => this.store.dispatch(LocalesActions.selectedLocale({ locale }))
    };

    queries: LocalesQueries = {
        attributeSelectedLocales$: this.store.select(LocalesSelectors.getAttributeLocaleFields),
        localeMappings$: this.store.select(LocalesSelectors.getLocaleMappings),
        localeOptions$: this.store.select(LocalesSelectors.getLocaleOptions),
        localeSelected$: this.store.select(LocalesSelectors.getLocaleSelected),
        origin$: this.store.select(LocalesSelectors.getOrigin),
        saved$: this.store.select(LocalesSelectors.getSaved)
    };

    constructor(private store: Store<CoreState>) { }

}
